import type { ReactNode } from 'react';

interface AppProps {
	url?: string;
	locale?: string;
	routePrefix?: string;
	cssHrefs?: string[];
	children: ReactNode;
}

export function App({ url = '/', locale = 'en-US', routePrefix = '/', cssHrefs, children }: AppProps) {
	return (
		<html lang={locale}>
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				{cssHrefs?.map((href) => (
					<link key={href} rel="stylesheet" href={href} />
				))}
				<script
					// biome-ignore lint/security/noDangerouslySetInnerHtml: anti-FOUC inline script
					dangerouslySetInnerHTML={{
						__html: `(function(){var t=localStorage.getItem('v1-theme');if(t==='dark'||(!t&&matchMedia('(prefers-color-scheme:dark)').matches))document.documentElement.setAttribute('data-theme','dark')})()`,
					}}
				/>
			</head>
			<body className="bg-background text-foreground antialiased" data-route-prefix={routePrefix}>
				{children}
			</body>
		</html>
	);
}
